module.exports = __webpack_public_path__ + "img/0a79f39.jpg";